import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import AmbulancePatientPaymentList from "./AmbulancePatientPaymentList";
import AmbulanceDriverPaymentList from "./AmbulanceDriverPaymentList";

const AmbulanceFees = () => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Tabs value={value} onChange={handleChange} textColor="primary">
        <Tab
          label={t("finance.ambulancePatientPaymentTab", {
            defaultValue: "Patient Payment",
          })}
        />
        <Tab
          label={t("finance.ambulanceDriverPaymentTab", {
            defaultValue: "Driver Payment",
          })}
        />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {value === 0 ? (
          <AmbulancePatientPaymentList />
        ) : (
          <AmbulanceDriverPaymentList />
        )}
      </Box>
    </Box>
  );
};

export default AmbulanceFees;
